export enum Condition {
    Active = 1,
    Archived
}
